import { filter } from './filter';
import type { Messages, TreeData } from './types';
import { CONFIG_DOC_ZOOM_UPDATE } from './types';
import { TreeUI } from './ui';
/**
 * TreeDiagram class that handles the visualization and interaction of tree data.
 *
 */
export class TreeDiagram {
    private TreeUI: TreeUI = new TreeUI();
    private treeData: TreeData;
    constructor() {
        window.addEventListener('message', (event) => this.messageHandler(event));
    }
    /**
     * Displays the tree diagram in the specified container.
     *
     * @param container - The ID of the container element to render the tree.
     * @param data - The tree data to display.
     * @param icon - The icon to use for the tree nodes.
     */
    public show(container: string, data: TreeData, icon: string) {
        this.treeData = data;
        this.TreeUI.render(container, data, icon);
    }
    /**
     * Sends a message to the parent window.
     *
     * @param message - The message to send.
     */
    private sendMessage(message: Messages): void {
        window.postMessage(message, document.location.origin);
    }
    /**
     * Handles incoming messages from the parent window.
     *
     * @param event - The message event containing the data.
     */
    public messageHandler(event: MessageEvent): void {
        const { data = {} } = event;
        const { type } = data;
        switch (type) {
            case '[view] search-config-doc': {
                const { query } = data.payload;
                const filteredTreeData = filter(this.treeData, query);
                this.TreeUI.applyFilter(filteredTreeData, query === '');
                break;
            }
            case '[view] expand-config-doc': {
                const { expand } = data.payload;
                this.TreeUI.toggleExpandAll(expand);
                break;
            }
            case '[view] zoom-config-doc': {
                const { level, center } = data.payload;
                const newLevel = this.TreeUI.zoomTree(level, center);
                if (newLevel !== level) {
                    // Notify about change
                    this.sendMessage({
                        type: CONFIG_DOC_ZOOM_UPDATE,
                        level: newLevel
                    });
                }
                break;
            }
        }
    }
}
